/// FOURJS_START_COPYRIGHT(D,2019)
/// Property of Four Js*
/// (c) Copyright Four Js 2019, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("KeyboardPrefixedConsoleLogProvider", ["LogProviderBase"], function (context, cls) {
  /**
   * Console log provider to handle all keyboard logs
   * @class KeyboardPrefixedConsoleLogProvider
   * @memberOf classes
   * @extends classes.LogProviderBase
   */
  class KeyboardPrefixedConsoleLogProvider extends cls.LogProviderBase /** @lends classes.PrefixedConsoleLogProvider.prototype */ {
    /**
     * @inheritDoc
     */
    constructor(prefix, prefixStyle) {
      super(prefix, prefixStyle);
      const _prefix = (prefixStyle ? "%c" : "") + prefix;
      this._logger = {
        debug: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.debug(...args);
        },
        log: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.log(...args);
        },
        info: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.info.apply(console, args);
        },
        warn: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.warn(...args);
        },
        error: function () {
          const args = Array.prototype.slice.apply(arguments);
          if (prefixStyle) {
            args.unshift(prefixStyle);
          }
          args.unshift(_prefix);
          console.error(...args);
        },
        record: function () {
          const t = new Date().getTime();
          const args = Array.prototype.slice.call(arguments);
          const bufferedKey = args[1];
          const eventKey = args[2];

          const keyMatch = args[0].match(/(Delayed|onKeyDown|processKey).*: (.*)/);

          const entry = {
            provider: prefix.replaceAll(/\s/g, ""), // Change [KEYBOARD   ] to [KEYBOARD]
            t: t,
            type: keyMatch ? keyMatch[1] : "unknown",
            bufferedKey: bufferedKey,
            eventKey: eventKey
          };
          context.LogService.record(entry);
        }
      };
    }

    /**
     * @inheritDoc
     */
    getLogger() {
      return this._logger;
    }
  }

  cls.KeyboardPrefixedConsoleLogProvider = KeyboardPrefixedConsoleLogProvider;
});
